import { IconProps } from ".";

export const NavDocsIcon: React.FC<IconProps> = ({ className, ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M4.31216 15.3118C6.29216 15.4545 8.01594 16.2645 9.03192 16.8532C9.63267 17.201 10.3673 17.201 10.9681 16.8532C11.9841 16.2645 13.7078 15.4545 15.6878 15.3118C16.7005 15.2388 17.5 14.428 17.5 13.4128V4.79476C17.5 3.65152 16.4995 2.77504 15.3635 2.89909C13.5205 3.10098 11.9281 3.85423 10.9681 4.41125C10.3673 4.75909 9.63267 4.75909 9.03192 4.41125C8.07189 3.85423 6.47946 3.10098 4.63648 2.89909C3.49973 2.77504 2.5 3.65152 2.5 4.79476V13.4128C2.5 14.428 3.29946 15.2388 4.31216 15.3118Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 8.04199V13.669"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
